import Id from './Id';
import Status from './Status';
import CompletedDate from './CompletedDate';
import CreatorUser from './CreatorUser';
import Storage from './Storage';
import ReceiptNumber from './ReceiptNumber';
import OwnCompany from './OwnCompany';
import StorageUser from './StorageUser';
import Created from './Created';
import Updated from './Updated';
import IsStockist from './IsStockist';

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Status: 'Státusz',
  Storage: 'Raktár',
  IsStockist: 'Besz. ár végleges',
  CompletedDate: 'Teljesítés dátuma',
  CreatorUser: 'Rögzítette',
  OwnCompany: 'Saját cég',
  StorageUser: 'Raktár vezető',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Storage',
}, {
  value: 'IsStockist',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'Updated',
}, {
  value: 'OwnCompany',
}, {
  value: 'StorageUser',
}, {
  value: 'Created',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Status',
}, {
  value: 'IsStockist',
}, {
  value: 'Storage',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  Status,
  Storage,
  CompletedDate,
  CreatorUser,
  OwnCompany,
  StorageUser,
  Created,
  Updated,
  IsStockist,
};
